const reservationEn = {
  "arriving_status": "Arriving: {{count}} reservation(s), {{guests}} guest(s)",
  "in_restaurant_status": "In restaurant: {{count}} reservation(s), {{guests}} guest(s)",
  "reservation": "Reservation",
  "waiting_list": "Waiting list",
  "not_approved": "Pending approval",
  "not_assigned_to_table": "Not assigned to a table",
  "arrived_guests": "Checked-in guests",
  "guest_note": "Guest note",
  "guest_name": "Name",
  "guest_email": "Email",
  "guest_phone": "Phone number",
  "guests_comment": "Guest's comment",
  "source": "Source",
  "reservation_date": "Reservation date",
  "reservation_time": "Reservation time",
  "guest_count": "Number of guests",
  "add_reservation": "Add reservation",
  "not_arrived": "Not arrived",
  "reservation_fee_table_title": "Reservations with fees during the selected period",
  "sent_sms_table_title": "Sent SMS during the selected period",
  "invoices_table_title": "Invoices during the selected period",
  "reservation_fee": "Reservation fee",
  "coupon_code": "Coupon code",
  "reservation_created_at": "Reservation created at",
  "reservation_labels": "Reservation labels",
  "guest_labels": "Guest labels",
  "guest_internal_comment": "Guest internal comment",
  "no_shows": "No-shows",
  "late_cancellations": "Late cancellations",
  "reservedon": "Reservation time",
  "occupancy": "Occupancy",
  "default_sources": {
    "email": "Email",
    "phone": "Phone",
    "other": "Other"
  },
  "reservation_details_saved": "Reservation details saved successfully",
  "reservation_guest_info_saved": "Guest information saved successfully",
  "approved": "Status",
  "approved_options": {
    "-1": "Deleted",
    "0": "Pending approval",
    "1": "Approved",
    "2": "Arrived",
    "3": "No-show",
    "4": "Departed",
    "5": "Partially arrived"
  },
  "approved_statistics": {
    "arrived": "Arrived",
    "approved": "Approved",
    "deleted": "Deleted",
    "n_a": "N/A",
    "no_show": "No-show",
    "walk_in": "Walk-in"
  },
  "reservation_length_not_set_placeholder": "Will be set based on save time",
  "send_confirmation_email": "Confirmation email",
  "message_language_options": {
    "hu": "Hungarian",
    "unknown": "Unknown",
    "en": "English",
    "ru": "Russian",
    "de": "German",
    "fr": "French",
    "es": "Spanish",
    "it": "Italian",
    "sk": "Slovak",
    "uk": "Ukrainian",
    "hr": "Croatian",
    "he": "Hebrew"
  },
  "walkin": "Walk-in guest",
  "confirm_message_language": "Confirmation email language",
  "editor_tabs": {
    "reservation": "Reservation",
    "guest": "Guest",
    "guest_history": "Guest history",
    "email": "Email",
    "sms": "SMS",
    "reviews": "Reviews",
    "merge": "Merge",
    "attachments": "Attachments",
    "ntak_history": "POS consumption data",
    "old_states": "Modifications"
  },
  "reservations_without_tables": "Reservations without tables",
  "create_new_reservation": "Create new reservation",
  "new_resrvation_tabs": {
    "reservation": "Reservation",
    "walkin": "Walk-in"
  },
  "hungarian_or_foreign": "Domestic or foreign guest?",
  "no_name_saved": "No name provided",
  "walkin_saved": "Walk-in guest saved successfully",
  "reservation_saved": "Reservation saved successfully",
  "reservation_approved": "Reservation approved",
  "reservation_declined": "Reservation declined",
  "reservation_deleted": "Reservation deleted",
  "auto_apply_is_on": "Auto-assignment",
  "seat_reservation": "Assign to table",
  "unseat_reservation": "Remove from table",
  "seat_successful": "Successfully assigned to table",
  "unseat_successful": "Successfully removed from table",
  "arrived": "Arrived",
  "no_show": "No-show",
  "partially_arrived": "Partially arrived",
  "reservation_status_updated": "Reservation status updated",
  "reservation_ended": "Departed",
  "reset_status": "Reset status",
  "status_actions": {
    "approve": "Approve",
    "decline": "Decline",
    "delete": "Delete",
    "reset": "Reset",
    "arrived": "Arrived",
    "partially_arrived": "Partially arrived",
    "noshow": "No-show",
    "ended": "Departed",
    "seat": "Assign to table",
    "unseat": "Remove from table"
  },
  "guests_per_day_30_days": "Guests per day (last 30 days)",
  "guests_per_day_12_weeks": "Guests per week (last 12 weeks)",
  "guests_per_day_12_months": "Guests per month (last 12 months)",
  "reservation_country_hungary": "Hungary",
  "reservation_country_foreign": "Foreign",
  "reservation_country_unknown": "No phone number provided",
  "reservations_by_source": "Guests by source",
  "reservations_by_country": "Guests by country",
  "reservations_by_status": "Guests by status",
  "guest_distribution": "Guest distribution",
  "upcoming_reservations": "Upcoming reservations",
  "seated_reservations": "Arrived reservations",
  "reservaton_ends": "Reservation ends",
  "event_at_this_date": "At this time: ",
  "late_cancellation_helper_text": "The guest canceled less than 6 hours before arrival",
  "resend_confirmation_mail": "Resend confirmation email",
  "approval_resent": "Approval resent",
  "reservation_type": "Reservation type",
  "max_reservation_file_size_exceeded": "The attachment size exceeds the allowed maximum.",
  "max_attachment_file_size": "Max file size: ",
  "attachment_file_size": "Uploaded file size: ",
  "maximum_reservation_attachments_exceeded": "The total size of attachments for the reservation must not exceed {{maxSize}}.",
  "current_total_attachments_size": "Current total attachments size: {{size}}",
  "upload_not_allowed": "Upload not allowed",
  "change_time_confirmation": "Are you sure you want to change the reservation time?",
  "evict_confirmation": "Are you sure you want to remove this reservation from the table?",
  "no_table_section": "No table",
  "timetable_settings": "Timetable settings",
  "timetable_allow_eviction": "Allow dragging to occupied table",
  "timetable_allow_time_change": "Allow changing time by dragging",
  "timetable_allow_on_touch": "Allow dragging on touch devices",
  "timetable_show_no_table": "Show reservations without table",
  "timetable_group_by_time": "Group reservations by time",
  "timetable_show_full_day": "Show full day",
  "clear_tables_for_day": "Remove all reservations from tables",
  "clear_tables_confirm": "Are you sure you want to remove all reservations from tables for this day?",
  "clear_tables_success": "All reservations have been removed from tables successfully",
  "reservations_panel": "Reservations panel",
  "old_states_tip": "Ezen a foglaláson módosítást végzett a vendég. Az alábbiakban megtekintheti a foglalás korábbi állapotait, valamint a módosítások időpontját.",
  "old_states_warning": "A lista nem tartalmazza az admin felületen végzett változtatásokat"
};

export default reservationEn;
